import React from 'react';
import {withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from '../../components/Toolbar/Toolbar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import SymbolsList from "../../components/WorkTimeConfig/SymbolsList";
import SeasonsList from "../../components/WorkTimeConfig/SeasonsList";

const Symbols = (props) => {

    const {
        seasons,
        symbols,
        classes,
    } = props;

    return (
        <Layout>
            <Toolbar
                disableGutters
                // title={i18n.get('work_time.self_plural')}
                title={i18n.get('default.nav.symbols')}
                subtitle={''}
                items={[]}
            />
            <Grid container spacing={16} direction={'row'} alignItems={'stretch'}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <SymbolsList values={{symbols: symbols}}/>
                    </Paper>
                </Grid>

            </Grid>
        </Layout>
    );
};

const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 0.25,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 1,
            marginBottom: theme.spacing.unit * 3,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(Symbols);
